import { request, exportCsvData, importData, downloadTemplate } from './api';
import { GroupInterface } from '../types';

const BASE_PATH = `/groups`;

interface SendReqConfig {
  method?: 'GET' | 'POST' | 'PUT' | 'DELETE';
  id?: string;
  data?: Partial<GroupInterface>;
  params?: string;
}

export async function sendReq({ method = 'GET', id, data, params = '' }: SendReqConfig = {}): Promise<any> {
  return await request({ method, id, data, params, basePath: BASE_PATH });
}

export async function getGroups(params?:string): Promise<{ data: GroupInterface[] }> {
  return await sendReq({params});
}

export async function exportGroups(params?: string): Promise<void> {
  return await exportCsvData(BASE_PATH, params);
}

export async function importGroups(data: any[]): Promise<any> {
  return await importData(BASE_PATH, data);
}

export async function downloadGroupsTemplate(): Promise<void> {
  return await downloadTemplate(BASE_PATH);
}

export async function createGroup(data: Partial<GroupInterface>): Promise<GroupInterface> {
  return await sendReq({ method: 'POST', data });
}

export async function updateGroup(id: string, data: Partial<GroupInterface>): Promise<GroupInterface> {
  return await sendReq({ method: 'PUT', id, data });
}

export async function deleteGroup(id: string): Promise<void> {
  return await sendReq({ method: 'DELETE', id });
} 